import { render, staticRenderFns } from "./fs-popper-pr-edit.vue?vue&type=template&id=3169a086"
import script from "./fs-popper-pr-edit.vue?vue&type=script&lang=js"
export * from "./fs-popper-pr-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3169a086')) {
      api.createRecord('3169a086', component.options)
    } else {
      api.reload('3169a086', component.options)
    }
    module.hot.accept("./fs-popper-pr-edit.vue?vue&type=template&id=3169a086", function () {
      api.rerender('3169a086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/poppers/fs-popper-pr-edit.vue"
export default component.exports